import { ReactNode, useEffect, useState } from 'react';
import './HideOnScroll.css';
import { useSession } from '../../../state/session';

type HideOnScrollProps = { children: ReactNode };
export const HideOnScroll = ({ children }: HideOnScrollProps): JSX.Element => {
	const [showSearchbar, setShowSearchbar] = useState(true);
	const { user } = useSession();
	const specialsOnlyLayout = user?.specialsOnly;

	useEffect(() => {
		let lastScrollTop = window.scrollY;
		function scrollListener() {
			const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
			const show = scrollTop <= lastScrollTop;
			lastScrollTop = Math.max(0, scrollTop);
			if (showSearchbar !== show) setShowSearchbar(show);
		}

		window.addEventListener('scroll', scrollListener);
		return () => window.removeEventListener('scroll', scrollListener);
	});

	return (
		<div className={`hide-on-scroll ${showSearchbar ? 'show' : ''} ${specialsOnlyLayout ? 'specials-only' : ''}`}>
			{children}
		</div>
	);
};
